export default "__VITE_ASSET__DrQSDSBF__"